<p-toast> </p-toast>
<p-confirmDialog
  class="documentTemplateMangementConfirmationDialog"
  icon="pi pi-exclamation-triangle"
  rejectButtonStyleClass="p-button-outlined"
>
</p-confirmDialog>
<app-top-bar [topBarTitle]="topBarTitle">
</app-top-bar>
  <div class="bpt-main-content-container" *ngIf="isScreenAccessible else screenNotAccessible">

    <div class="grid documentTemplateManagement">
      <div class="col-6">
        <app-document-template-global-list></app-document-template-global-list>
      </div>
      <div class="col-6">
        <app-eqms-scope-configuration></app-eqms-scope-configuration>
      </div>
    </div>
  </div>
  <ng-template #screenNotAccessible>
    <app-error [errorMessage]="errorMessage"></app-error>
  </ng-template>
